import { useLocale } from 'react-aria';
import styled from '@emotion/styled';
import { ReactNode, useLayoutEffect } from 'react';

interface AppContainerProps {
  children: ReactNode;
}

export function AppContainer(props: AppContainerProps) {
  const { locale, direction } = useLocale();

  // Overwrite HTML lang and dir attributes for better accessibility
  useLayoutEffect(() => {
    document.documentElement.lang = locale;
    document.documentElement.dir = direction;
  }, [direction, locale]);

  return (
    <AppContainer.Root lang={locale} dir={direction}>
      {props.children}
    </AppContainer.Root>
  );
}

AppContainer.Root = styled.div`
  height: 100%;
`;
